import { api, ApiResponse, PaginatedResponse } from './api';

export interface ActivityUser {
  id: string;
  name: string;
  email: string;
  avatar?: string;
}

export interface Activity {
  id: string;
  workspace_id: string;
  user_id: string;
  subject_type: string;
  subject_id: string;
  action: string;
  description?: string;
  properties?: Record<string, any>;
  old_values?: Record<string, any>;
  new_values?: Record<string, any>;
  created_at: string;
  updated_at: string;
  user?: ActivityUser;
}

export interface ActivityFilters {
  subject_type?: string;
  subject_id?: string;
  action?: string;
  user_id?: string;
}

export const activityApi = {
  getPaginated: async (workspaceId: string, page = 1, perPage = 30, filters?: ActivityFilters): Promise<PaginatedResponse<Activity>> => {
    const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
    if (filters?.subject_type) params.append('subject_type', filters.subject_type);
    if (filters?.subject_id) params.append('subject_id', filters.subject_id);
    if (filters?.action) params.append('action', filters.action);
    if (filters?.user_id) params.append('user_id', filters.user_id);
    const response = await api.get<ApiResponse<PaginatedResponse<Activity>>>(`/api/v1/workspaces/${workspaceId}/activities?${params.toString()}`);
    return response.data.data!;
  },
};
